import { render } from "./Title.vue?vue&type=template&id=a09bac5a&scoped=true"
const script = {}

import "./Title.vue?vue&type=style&index=0&id=a09bac5a&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a09bac5a"],['__file',"src/components/survey/Title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a09bac5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a09bac5a', __exports__)) {
    console.log('reload')
    api.reload('a09bac5a', __exports__)
  }
  
  module.hot.accept("./Title.vue?vue&type=template&id=a09bac5a&scoped=true", () => {
    console.log('re-render')
    api.rerender('a09bac5a', render)
  })

}


export default __exports__